var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatinumMilestone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2361 2.17311C20.3276 1.54291 21.6724 1.54291 22.7639 2.17311L36.4226 10.0589C37.5141 10.6891 38.1865 11.8538 38.1865 13.1142V28.8858C38.1865 30.1462 37.5141 31.3109 36.4226 31.9411L22.7639 39.8269C21.6724 40.4571 20.3276 40.4571 19.2361 39.8269L5.5774 31.9411C4.48587 31.3109 3.81347 30.1462 3.81347 28.8858V13.1142C3.81347 11.8538 4.48587 10.6891 5.5774 10.0589L19.2361 2.17311Z",
    fill: "url(#paint0_linear_577_28292)",
    stroke: "url(#paint1_linear_577_28292)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1929 27L17 21.2829V19.9356H18.0643C18.49 19.9356 18.8625 19.8749 19.1818 19.7535C19.5129 19.62 19.7849 19.4318 19.9978 19.1891C20.2225 18.9463 20.3762 18.655 20.459 18.3151H17V16.9678H20.4412C20.3703 16.6522 20.2461 16.373 20.0687 16.1303C19.9032 15.8875 19.6785 15.6993 19.3947 15.5658C19.1227 15.4202 18.7916 15.3473 18.4013 15.3473H17V14H25V15.3473H22.2151C22.4161 15.578 22.5817 15.8268 22.7118 16.0938C22.8537 16.3609 22.9483 16.6522 22.9956 16.9678H25V18.3151H23.031C22.9128 19.2134 22.5758 19.9174 22.02 20.4272C21.4642 20.9248 20.7487 21.2647 19.8736 21.4468L23.3503 27H20.1929Z",
    fill: "url(#paint2_linear_577_28292)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_577_28292",
    x1: 21.0001,
    y1: -0.903604,
    x2: 21.0001,
    y2: 42.9036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B4B4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_577_28292",
    x1: 12.6163,
    y1: 16.2258,
    x2: 29.7447,
    y2: 34.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED4DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_577_28292",
    x1: 19.4031,
    y1: 19.0223,
    x2: 24.2323,
    y2: 22.1287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED4DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumMilestone);
export default __webpack_public_path__ + "static/media/platinum_milestone.4bfe0f9b10d6da1b1c47233d0533ac9f.svg";
export { ForwardRef as ReactComponent };